var exports = {
  "S": "x8b4e8595--397a00--pagination-sentinel",
};

module.exports = exports;
